import React, { useState } from 'react';
import { ArrowLeft, ArrowRight, Star } from 'lucide-react';
import { testimonials, whatsappLink } from '../data/mock';
import { SectionLabel } from './About';

const Testimonials = () => {
  const [page, setPage] = useState(0);
  const perPage = 2;
  const pages = Math.ceil(testimonials.length / perPage);
  const current = testimonials.slice(page * perPage, page * perPage + perPage);

  const next = () => setPage((p) => (p + 1) % pages);
  const prev = () => setPage((p) => (p - 1 + pages) % pages);

  return (
    <section className="relative py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-6">
        <SectionLabel>Nossos Clientes</SectionLabel>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <h2 className="md:col-span-8 font-display text-[40px] sm:text-[54px] md:text-[68px] leading-[1.05] text-cream">
            O que falam sobre a<br />
            <span className="text-cream/55">experiência BRN</span>
          </h2>
          <div className="md:col-span-4 flex md:justify-end">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center rounded-full border border-cream/25 px-6 py-2.5 text-sm text-cream hover:bg-cream hover:text-[#0b0807] transition-colors"
            >
              Agendar meu corte
            </a>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {current.map((t, i) => (
            <div key={`${page}-${i}`} className="rounded-2xl border border-cream/10 bg-[#120e0c] p-7 md:p-9 fade-up">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} className="w-4 h-4" style={{ color: '#e6dccd', fill: '#e6dccd' }} />
                ))}
              </div>
              <p className="text-cream-soft text-[14.5px] leading-relaxed">“{t.text}”</p>
              <p className="mt-6 text-cream font-medium">{t.name}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {Array.from({ length: pages }).map((_, i) => (
              <span
                key={i}
                className={`h-px transition-all ${i === page ? 'w-10 bg-cream' : 'w-6 bg-cream/30'}`}
              />
            ))}
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full border border-cream/25 flex items-center justify-center text-cream/80 hover:bg-cream hover:text-[#0b0807] transition-colors"
              aria-label="Anterior"
            >
              <ArrowLeft className="w-4 h-4" />
            </button>
            <button
              onClick={next}
              className="w-10 h-10 rounded-full border border-cream/25 flex items-center justify-center text-cream/80 hover:bg-cream hover:text-[#0b0807] transition-colors"
              aria-label="Próximo"
            >
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
